import { render, staticRenderFns } from "./Gbp.vue?vue&type=template&id=67ec7a51&scoped=true&"
import script from "./Gbp.vue?vue&type=script&lang=js&"
export * from "./Gbp.vue?vue&type=script&lang=js&"
import style0 from "./Gbp.vue?vue&type=style&index=0&id=67ec7a51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ec7a51",
  null
  
)

export default component.exports